import React from "react";
import NavBar from "../MyComponents/NavBar";
import "../MyComponents/reports.css";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function EthiopiaIVRDashboard() {
  const initialToken = localStorage.getItem("token");
  const history = useHistory();

  useEffect(() => {
    if (!initialToken) {
      history.push("/login");
    }
  }, [initialToken, history]);
  return (
    <>
      <NavBar detailView={true} />
      <div>
        <iframe
          title="Farmer Organisation Dashboard"
          width="600"
          height="373.5"
          src="https://app.powerbi.com/view?r=eyJrIjoiZjM5ZDk1Y2ItYzJmOS00ODVmLWJkMDktMGZjNjc4YzE2YzY2IiwidCI6ImIyYTViZGZhLTU0MzktNGUxMy04YTBlLWRmODIwMTJiMTQ2YSIsImMiOjZ9"
          frameborder="0"
          allowFullScreen="true"
          id="reports"
        ></iframe>
      </div>
    </>
  );
}
